import { Form, Formik } from 'formik';
import React from 'react';
import { Outlet } from 'react-router-dom';

import ErrorsTooltip from '@/components/ErrorsTooltip';
import { SubmitBtn } from '@/components/Forms';
import ContainerForInputs from '@/components/Forms/ContainerInput';
import { useEditProfileForm } from '@/Utils/formHooks/useEditProfileForm';

import RequestToSendSmsModal from './Modals/RequestToSendSmsModal';

const EditProfileForm: React.FC = () => {
  const { errors, user, ...formData } = useEditProfileForm();
  const formatKey = (str: string) => {
    return str
      .replace(/_/g, " ") 
      .replace(/\b\w/g, (char) => char.toUpperCase()) 
  };

  return (
    <>
      <Formik {...formData}>
        {({ errors: formErrors, submitCount }) => (
          <Form className='justify-center w-full flex flex-wrap mx-auto profile-form'>
            <ErrorsTooltip errors={errors} className='mt-12' />

            <div className='w-full pt-14'>
              <Outlet />
            </div>

            {submitCount > 0 && Object.keys(formErrors).length ? (
              <>
                {Object.keys(formErrors).map((key, index) => (
                  <p key={index} className='text-customRed p-2 w-full font-bold'>
                    {formatKey(key)}: {Object.values(formErrors)[index]}
                  </p>
                ))}
              </>

              // ))
            ) : null}

            <ContainerForInputs>
              <SubmitBtn text='Save Account Details' />
            </ContainerForInputs>
          </Form>
        )}
      </Formik>

      <RequestToSendSmsModal />
    </>
  );
};
export default EditProfileForm;
